/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { tickBoxClassName } from './styles';
import { type TickBoxProps } from './types';

const selectedStyles = css({
	backgroundColor: token('color.icon.information'),
	color: token('color.icon.inverse'),
});

const wrapperStyles = css({
	font: token('font.body'),
	width: token('space.200'),
	height: token('space.200'),
	position: 'absolute',
	top: token('space.075'),
	left: token('space.075'),
	borderRadius: token('space.250'),
	color: 'transparent',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		display: 'block',
	},
	display: 'grid',
	placeItems: 'center',
	transition: 'all .3s',
});

export const TickBoxWrapper: {
	(props: TickBoxProps): JSX.Element;
	displayName: string;
} = (props: TickBoxProps): JSX.Element => {
	return (
		<div
			id="tickBoxWrapper"
			data-testid="media-card-tickbox"
			css={[wrapperStyles, props.selected && selectedStyles]}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={tickBoxClassName}
		>
			{props.children}
		</div>
	);
};

TickBoxWrapper.displayName = 'TickBoxWrapper';
